import React from 'react';
import { toast } from 'react-toastify';
import { FaRegCopy } from 'react-icons/fa';
import { copiarTexto } from '../util/util';

// "1985-03-04" ou "1985-03-04 00:00:00" vira "04/03/1985"; o que não for data passa como veio.
const dataBr = (v) => {
    const m = String(v ?? '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : String(v ?? '').trim();
};

/**
 * Conteúdo do popover do nome, na planilha de emissão: o cadastro do participante que o Aéreo copia
 * para a reserva, no mesmo formato das observações (valor e, embaixo, o rótulo). Só os campos
 * preenchidos entram, cada um com o copiar. `participante` é a linha da tela: `nome`, `cpf` e o bloco
 * `cadastro` que o back manda.
 */
export default function DadosParticipante({ participante }) {
    const c = participante.cadastro ?? {};
    const campos = [
        ['Nome completo', participante.nome],
        ['CPF', participante.cpf],
        ['Data de nascimento', dataBr(c.nascimento)],
        ['RG', c.rg],
        ['Passaporte', c.passaporte],
        ['Validade do passaporte', dataBr(c.passaporteVencimento)],
        ['One Key ID', c.oneKey],
    ].map(([rotulo, valor]) => [rotulo, String(valor ?? '').trim()]).filter(([, texto]) => texto);

    const copiar = async (rotulo, texto) => {
        if (await copiarTexto(texto)) toast.success(`${rotulo} copiado.`);
        else toast.error('Não foi possível copiar.');
    };

    return (
        <div className="d-flex flex-column gap-2">
            {campos.map(([rotulo, texto]) => (
                <div key={rotulo} className="d-flex align-items-start gap-2">
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div>{texto}</div>
                        <div className="fin-pp__cell-muted" style={{ fontSize: 11, whiteSpace: 'normal' }}>{rotulo}</div>
                    </div>
                    <button type="button" className="btn btn-sm p-0 border-0 bg-transparent shadow-none d-inline-flex"
                        title={`Copiar ${rotulo}`} aria-label={`Copiar ${rotulo}`}
                        style={{ color: '#2d7ff9', marginTop: 2 }} onClick={() => copiar(rotulo, texto)}>
                        <FaRegCopy size={12} />
                    </button>
                </div>
            ))}
            {campos.length === 1 && (
                <div className="fin-pp__cell-muted" style={{ fontSize: 11, whiteSpace: 'normal' }}>Sem documentos no cadastro.</div>
            )}
        </div>
    );
}
